
export const passwordValidation = (value: string) => {
  const passwordPattern = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!"#$%&\'()*+,-./:;<=>?@\\[\\]\\\\^_`{|}~ ])(?=.{8,})')
  return passwordPattern.test(value)
}